<template>
  <div class="banner section">
    <mq-layout :mq="['xl', 'hd', 'inf']">
      <img :src="banner.image" alt />
    </mq-layout>
    <mq-layout :mq="['xs', 'sm', 'ms', 'md', 'lg']">
      <img :src="banner.mobile_image!=undefined ? banner.mobile_image : banner.image" alt />
    </mq-layout>
    <div class="container">
      <div class="banner-caption">
        <h1 v-html="$t(banner.title)" v-if="banner.title"></h1>
        <p v-html="$t(banner.description)" v-if="banner.description"></p>
        <a v-if="banner.cta_text" :href="banner.cta_action">
          <button type="button" class="button light">
            {{$t(banner.cta_text)}}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  props: ['banner'],
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.banner {
  position: relative;
  height: calc(100vh - 75px);
  max-height: 870px;
  display: flex;
  align-items: center;
  margin-top: 75px;

  @include mq($lg) {
    height: 100vh;
    align-items: flex-end;
    margin-top: 55px;
  }

  @include mq(ms) {
    margin-top: 45px;

    .button{
      width: 100%;
    }
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 0;
  }
  .container {
    position: relative;
    flex: 1 0 auto;
    color: #fff;

    @include mq($lg) {
      margin-bottom: 70px;
    }

    .banner-caption {
      max-width: 700px;
      h1 {
        font-size: 32px;
        font-family: $font-bold;
        margin: 0;
        text-transform: uppercase;

        @include mq($lg) {
          font-size: 24px;
        }
      }
      p {
        margin-top: 30px;
        margin-bottom: 30px;
        font-family: $font-light;
      }
    }
  }
}
</style>
